import React, { useEffect } from 'react'
import { Tabs } from 'antd';
import { Home } from '../routes/home';
import { PrivacyPolicy } from '../routes/privacy-policy';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

const { TabPane } = Tabs;

function getMobileOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor;

  if (/windows phone/i.test(userAgent)) {
    return "windows phone";
  }
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "unknown";
}

function DetectAndServe() {
  let os = getMobileOperatingSystem();
  if (os === "android") {
    window.open("https://play.google.com/store/apps/details?id=com.peyvar.countrycup", "_self");
  } else if (os === "ios") {
    window.open("https://apps.apple.com/am/app/country-cup/id1561835155", "_self");
  }
}

function Download(){

  useEffect(() => {
    DetectAndServe()
  }, [])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <h1 style={{ textAlign: 'center' }}>Redirecting to store...</h1>
    </div>
  )
}

function MainTabs(){
  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Home" key="1">
        <Home />
      </TabPane>
      <TabPane tab="Privacy policy" key="2">
        <PrivacyPolicy />
      </TabPane>
    </Tabs>
  )
}

function PrivacyPolicyPage(){
  return (
    <Tabs defaultActiveKey="2">
      <TabPane tab="Home" key="1">
        <Home />
      </TabPane>
      <TabPane tab="Privacy policy" key="2">
        <PrivacyPolicy />
      </TabPane>
    </Tabs>
  )
}

function Routes(){
  return (
    <Router>
      <Switch>
        <Route path="/download">
          <Download />
        </Route>
        <Route path="/privacy-policy">
          <PrivacyPolicyPage />
        </Route>
        <Route path="/">
          <MainTabs />
        </Route>
      </Switch>
    </Router>
  )
}

export { Routes }